module.exports = __webpack_public_path__ + "img/angus_niu2.05f284c8.png";